import React from "react";
import styles from "./SkipToContent.module.scss";

type NodeTarget = string | React.RefObject<HTMLElement>;

type Props = {
  target: NodeTarget;
  linkTitle?: string;
};

const SkipToContent = ({ target, linkTitle = "Skip To Content" }: Props) => {
  const clickHandler = ((target: NodeTarget) => {
    const node: HTMLElement | null =
      typeof target === "string"
        ? document.querySelector(target)
        : target.current;

    if (!node?.hasAttribute) return;
    !node.hasAttribute("tabindex") && node.setAttribute("tabindex", "-1");
    node.focus();
  }).bind(null, target);

  return (
    <button onClick={clickHandler} className={styles["SkipLink"]}>
      {linkTitle}
    </button>
  );
};

export default SkipToContent;
